export var ACTION;
(function (ACTION) {
    ACTION["REDIRECT_ACTION"] = "REDIRECT_ACTION";
    ACTION["RETRY_PAYMENT"] = "RETRY_PAYMENT";
    ACTION["RETRY_PAYMENT_LOAN_EXPIRED"] = "RETRY_PAYMENT_LOAN_EXPIRED";
    ACTION["RETRY_PAYMENT_FORECLOSURE"] = "RETRY_PAYMENT_FORECLOSURE";
    ACTION["RETRY_INTEREST_COLLECTION_PAYMENT"] = "RETRY_INTEREST_COLLECTION_PAYMENT";
    ACTION["RETRY_PAYMENT_SHORTFALL"] = "RETRY_PAYMENT_SHORTFALL";
})(ACTION || (ACTION = {}));
export var PaymentStatuses;
(function (PaymentStatuses) {
    PaymentStatuses["COLLECTION_COMPLETE"] = "COLLECTION_COMPLETE";
    PaymentStatuses["SETTLED"] = "SETTLED";
    PaymentStatuses["SUCCESS_WITH_LENDER_RECON_FAILED"] = "SUCCESS_WITH_LENDER_RECON_FAILED";
    PaymentStatuses["FAILED"] = "FAILED";
    PaymentStatuses["PENDING_SETTLEMENT"] = "PENDING_SETTLEMENT";
    PaymentStatuses["CANCELLED"] = "CANCELLED";
})(PaymentStatuses || (PaymentStatuses = {}));
